import { X, Check, Lock, Trash2 } from 'lucide-react';
import ModalBackdrop from '@/components/ModalBackdrop';

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  danger?: boolean;
}

export default function ConfirmationModal({
  open,
  title,
  description,
  confirmLabel = 'Bekräfta',
  cancelLabel = 'Avbryt',
  onConfirm,
  onCancel,
  danger = false,
}: ConfirmationModalProps) {
  if (!open) return null;
  return (
    <ModalBackdrop>
      <div className="w-full max-w-md rounded-xl bg-card border border-border shadow-xl overflow-hidden">
        <div className="flex items-center justify-between border-b border-border p-4">
          <h3 className="text-lg font-semibold flex items-center gap-2">
            {danger ? (
              <Trash2 className="h-5 w-5 text-destructive" />
            ) : (
              <Lock className="h-5 w-5 text-primary" />
            )}
            {title}
          </h3>
          <button
            onClick={onCancel}
            className="rounded-lg p-2 hover:bg-muted transition-colors"
            aria-label={cancelLabel}
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          {description && <p className="text-sm text-muted-foreground">{description}</p>}

          <div className="flex gap-3 pt-2">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-2 rounded-lg border border-border hover:bg-muted transition-colors"
            >
              {cancelLabel}
            </button>
            <button
              onClick={onConfirm}
              className={
                `flex-1 px-4 py-2 rounded-lg flex items-center justify-center gap-2 transition-colors ${
                  danger
                    ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90'
                    : 'btn-primary-custom'
                }`
              }
            >
              {danger ? <Trash2 className="h-4 w-4" /> : <Check className="h-4 w-4" />}
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </ModalBackdrop>
  );
}
